module.exports = __webpack_public_path__ + "c7cab6095f1f525c158f48277051a2f1.svg";